// extracted by mini-css-extract-plugin
export default {"quote-box":"Quote_quote-box__w1JE0","author":"Quote_author__1W1zp"};